import type { FC } from 'react';
import { useEffect } from 'react';

import { useActionsContext } from 'components/molecules/RichTextInputV2';
import { useEntitySidebar } from 'screens/FlowDetails/context/EntitySidebarContext';

interface Props {
  onCreate?: (entity: { id: string; name: string }) => void;
  onCancel?: (errorMessage: string) => void;
}

const EntityPopup: FC<Props> = ({ onCreate, onCancel }) => {
  const { customState } = useActionsContext();
  const { openEntitySidebar, closeEntitySidebar } = useEntitySidebar();

  useEffect(() => {
    openEntitySidebar({
      stepType: customState?.flowStepType,
      upsertRef: {
        onUpsert: ({ name, id }) => {
          onCreate?.({
            name,
            id,
          });
        },
        onCancelUpsert: () => {
          onCancel?.('Error creating entity');
        },
      },
    });
    return closeEntitySidebar;
  }, [
    openEntitySidebar,
    customState?.flowStepType,
    closeEntitySidebar,
    onCreate,
    onCancel,
  ]);

  return null;
};

export default EntityPopup;
